module.exports = __webpack_public_path__ + "img/zaincash.a56807fe.png";